__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@ibk/dominioempresa";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ibk/shared-config", "0.1.0", () => (() => (__webpack_require__(44160))), 1);
			register("@ibk/shared-feature-flags", "1.0.0", () => (() => (__webpack_require__(60247))), 1);
			register("@ibk/shared-layout", "0.1.0", () => (() => (__webpack_require__(67273))), 1);
			register("@ibk/shared-translation", "0.1.0", () => (() => (__webpack_require__(32155))), 1);
			register("@ibk/shared-types", "0.1.0", () => (() => (__webpack_require__(91836))), 1);
			register("@ibk/shared-ui", "0.1.0", () => (() => (__webpack_require__(44742))), 1);
			register("@ibk/shared-utils", "0.1.0", () => (() => (__webpack_require__(71275))), 1);
			register("react-dom", "19.2.8", () => (() => (__webpack_require__(43144))), 1);
			register("react-hook-form", "7.61.1", () => (() => (__webpack_require__(80824))), 1);
			register("react-redux", "9.2.0", () => (() => (__webpack_require__(70541))), 1);
			register("react-router-dom", "7.18.2", () => (() => (__webpack_require__(56529))), 1);
			register("react-router", "7.18.2", () => (() => (__webpack_require__(27736))), 1);
			register("react", "19.2.8", () => (() => (__webpack_require__(14041))), 1);
			initExternal(26889);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};